import { Component } from '@angular/core';

@Component({
  selector: 'iris-card-footer',
  templateUrl: './iris-card-footer.component.html',
  styleUrls: ['./iris-card-footer.component.css'],
  standalone: false,
})
export class IrisCardFooterComponent {}
